import type { WhiteboardsEntrypointExperimentConfigState } from '../../../model/types';
import type { WHITEBOARD_ENTRYPOINT_EXPERIMENT_VARIANTS } from '../../../view/whiteboards-entrypoint-experiment/constants';
import type { State } from '../../types';

export const getWhiteboardsExperimentEntrypointConfig = (
	state: State,
): WhiteboardsEntrypointExperimentConfigState => state.config.whiteboardsEntrypointExperimentConfig;

export const getHasConfluenceAccess = (state: State): boolean =>
	getWhiteboardsExperimentEntrypointConfig(state).hasConfluenceAccess;

export const getHasConfluenceSpaces = (state: State): boolean =>
	getWhiteboardsExperimentEntrypointConfig(state).hasConfluenceSpaces;

export const getHasViewedPulse = (state: State): boolean =>
	getWhiteboardsExperimentEntrypointConfig(state).hasViewedPulse;

export const getWhiteboardEligibility = (
	state: State,
): {
	flow: 'coUse' | 'crossFlow' | null;
	cohort: WHITEBOARD_ENTRYPOINT_EXPERIMENT_VARIANTS | string;
} => getWhiteboardsExperimentEntrypointConfig(state).eligibility;
